// test167
(167 && 0);
